import '../cart.js';
import '../form.js';
import Swiper from 'swiper';
import {FreeMode, Navigation, Scrollbar, Thumbs} from 'swiper/modules';
import 'swiper/css/bundle';

$(document).ready(function () {
    // Product with optionseries
    if (intProductPricetypeno == 2) {
        // Select another option
        $('select[name*="OptionSerie"]').change(function () {
            if ($(this).find(':selected').data('href')) {
                // Go to the url from the option
                document.location = $(this).find(':selected').data('href');
            }
        });
    }

    // Add to cart
    AddToCart($('form#frmAddToCart button#btnAddToCart'), WebsiteSettingBlnShowAddToCartQtyField, true);

    // Mail on stock
    if (WebsiteSettingBlnMailOnStock) {
        // Clicking on button from mail on stock => ajax form
        $('input#btnMailStock').click(function () {
            var objInput = $('input#txtEmailStock');
            var objInputParent = objInput.parent();


            // Check if there's a correct e-mail entered => then add request to database
            $.post(strAjaxPath + 'mail-on-stock.php', 'intArticleNo=' + $('input#hdnArticleNo').val() + '&intPriceNo=' + $('input#hdnPriceNo').val() + '&strEmailStock=' + $('input#txtEmailStock').val(), function (data) {

                $('label[for="txtEmailStock"]').remove();
                objInput.removeClass('is-invalid');

                if (data.value == 0) {
                    // Error
                    objInput.addClass('is-invalid');
                    objInputParent.append('<label class="invalid-feedback" for="txtEmailStock">' + data.message + '</label>');
                } else {
                    // Notitication
                    objInputParent.parent().hide();
                    objInputParent.parent().parent().append('<div class="alert alert-success">' + data.message + '</div>');
                }
            }, 'json');
        });
    }

    // Check if there are linked products with an add-to-cart button
    if (intSizeRelatedProducts > 0) {
        AddToCart($('form.form-add-to-cart button.btn-basket'), false, true);
    }

    //ADD TO WISHLIST
    $('#add-to-wishlist').click(function () {
        var strWishlistArticles = GetLocalStorage('strWishlistArticles');

        var strParams = 'intArticleno=' + $(this).data('article');
        strParams += '&strType=add';
        strParams += '&strWishlistArticles=' + strWishlistArticles;

        $.post(strAjaxPath + 'wishlist/wishlist.php', strParams, function (objResponse) {
            if (objResponse != '') {
                // Save session storage
                SetLocalStorage('strWishlistArticles', objResponse.articles);

                $.post(strAjaxPath + 'wishlist/wishlist-popup.php', strParams, function (data) {
                    $.fancybox.open(
                        data,
                        {
                            afterLoad: function () {
                                // Move product to another another list
                                $('input[type=radio][name="wishlist"]').click(function () {
                                    var strValue = $(this).val();
                                    var strParams = 'intArticleno=' + $('#hdnArticle').val();
                                    strParams += '&strGiftlistno=' + strValue;
                                    var objInput = $(this);
                                    // Icons
                                    $('input[type=radio][name="wishlist"] + label').find('.fa-spin').addClass('hidden');
                                    objInput.next().find('.fa-spin').removeClass('hidden');

                                    setTimeout(function () {
                                        objInput.next().find('.fa-spin').addClass('hidden');
                                        objInput.next().find('.fa-check').removeClass('hidden');
                                    }, 1000);

                                    setTimeout(function () {
                                        objInput.next().find('.fa-check').addClass('hidden');
                                    }, 2000);

                                    // Update wish list
                                    $.post(strAjaxPath + 'wishlist/wishlist-update-list.php', strParams, function (data) {
                                        if (data == 'OK') {
                                            $('a#parent').attr('href', strPath + strLang + '/wishlist/' + strValue);
                                        }
                                    });
                                });


                                $('#new-list').click(function () {
                                    $('#frmWishlist').removeClass('hidden');
                                    $('#frmWishlist').addClass('flex');
                                    return false;
                                });

                                // Validate form to add new wishlist
                                FormValidateAddWishlist($('form#frmWishlist'));
                            },
                        },
                    );
                });
            }
        }, 'json');
        return false;
    });

//slider
    if ($('.swiper').length > 0) {
        let sliderThumbs = new Swiper('.gallery-thumbs', {
            modules: [Navigation, FreeMode],
            slidesPerView: 5,
            freeMode: true,
            watchSlidesProgress: true,
            spaceBetween: 8,

            // Navigation arrows
            navigation: {
                nextEl: '.button-next',
                prevEl: '.button-prev',
            },
        });

        let slider = new Swiper('.gallery-top', {
            modules: [Navigation, Thumbs, Scrollbar],
            // Optional parameters
            loop: false,

            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },

            // And if we need scrollbar
            scrollbar: {
                el: '.swiper-scrollbar',
            },
            thumbs: {
                swiper: sliderThumbs,
            },
        });
    }

    //save articleno when going to form for sales
    $("a.btn-sales-form").click(function (e) {
        var articleno = $(this).attr("data-articleno");
        localStorage.setItem("articleno", articleno);
    });
});

